(() => {
  angular
    .module('gm.common.phone', [])
    .factory('GmyPhone', GmyPhone);

  function GmyPhone(
    $window
  ) {
    'ngInject';

    const phoneUtils = $window.libphonenumber.PhoneNumberUtil.getInstance();

    return {
      isValidPhoneNumber,
      formatPhoneNumber,
      getPhoneCountryCode,
      getPhoneWithoutCountryCode,
      parsePhonenumber,
    };

    function isValidCaOrUs(phone, countryCode) {
      if (['CA', 'US'].indexOf(countryCode) > -1) {
        return phone.substr(0, 2) === '+1';
      }

      return true;
    }

    /**
     * Check the validity of phone number
     * @param {String} phone
     * @param {String} countryCode
     * @returns {boolean}
     */
    function isValidPhoneNumber(phone, origCountryCode = null) {
      let result;

      if (!phone) {
        return false;
      }

      try {
        const parsedPhone = phoneUtils.parse(phone);
        const countryCode = origCountryCode || phoneUtils.getRegionCodeForNumber(parsedPhone);

        result = phoneUtils.isValidNumberForRegion(parsedPhone, countryCode)
          && isValidCaOrUs(phone, countryCode);
      } catch (e) {
        return false;
      }

      return result;
    }

    function formatPhoneNumber(phone, countryCode = null) {
      return phone && isValidPhoneNumber(phone, countryCode)
        && phoneUtils.formatOutOfCountryCallingNumber(phoneUtils.parse(phone));
    }

    /**
     * Try to get phone country code
     * @param {String} phone
     * @returns {String|null}
     */
    function getPhoneCountryCode(phone) {
      try {
        const phoneObj = phoneUtils.parse(phone);
        return phoneUtils.getRegionCodeForNumber(phoneObj);
      } catch (e) {
        return null;
      }
    }

    function getPhoneWithoutCountryCode(phone) {
      try {
        const phoneObj = phoneUtils.parse(phone);
        const leading = phoneObj.hasItalianLeadingZero() ? '0' : '';

        return `${leading}${phoneObj.getNationalNumber()}`;
      } catch (e) {
        return null;
      }
    }

    function parsePhonenumber(number) {
      try {
        const phoneObj = phoneUtils.parse(number);

        return {
          nationalNumber: phoneObj.getNationalNumber(),
          prefix: phoneObj.getCountryCode(),
          countryCode: phoneUtils.getRegionCodeForNumber(phoneObj)
        };
      } catch (e) {
        return null;
      }
    }
  }
})();
